import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefOBGyExaminationLiquorDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationLiquor/GetDetail?` + params, null);

export const GetRefOBGyExaminationLiquorList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationLiquor/GetList?` + params, null);

export const CreateRefOBGyExaminationLiquor = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationLiquor/Create`, data);

export const UpdateRefOBGyExaminationLiquor = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationLiquor/Update`, data);

export const DeleteRefOBGyExaminationLiquor = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationLiquor/Delete`, data);